import { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Themes } from './config';
import { browserPreferencesResetEvent } from './browser-preferences';
import { themeChangedEvent } from './forum-theme';
import { browserUserPreferences } from './user-preferences';

export function ThemeAppearance() {
  const [theme, setTheme] = useState(() => browserUserPreferences().theme);

  useEffect(() => {
    const resetTheme = () => setTheme(browserUserPreferences().theme);
    window.addEventListener(browserPreferencesResetEvent, resetTheme);
    window.addEventListener(themeChangedEvent, resetTheme);
    window.addEventListener('storage', resetTheme);
    return () => {
      window.removeEventListener(browserPreferencesResetEvent, resetTheme);
      window.removeEventListener(themeChangedEvent, resetTheme);
      window.removeEventListener('storage', resetTheme);
    };
  }, []);

  useEffect(() => {
    const themeId = 'app-theme';
    const existingLink = document.getElementById(themeId) as HTMLLinkElement;

    const newLink = document.createElement('link');
    newLink.rel = 'stylesheet';
    const themeName: string = Themes.find(t => t.value === theme)?.value || 'lara-light-blue';
    newLink.href = `/themes/${themeName}/theme.css`;
    if (existingLink?.getAttribute('href') === newLink.getAttribute('href')) return;

    let loaded = false;
    newLink.onload = () => {
      loaded = true;
      if (existingLink?.parentNode) {
        existingLink.parentNode.removeChild(existingLink);
      }
      newLink.id = themeId;
    };

    document.head.appendChild(newLink);

    return () => { newLink.onload = null; if (!loaded) newLink.remove(); };
  }, [theme]);

  return null;
}

export default function ThemeSwitcher() {
  const [theme, setTheme] = useState(localStorage.getItem('selected-theme') || 'lara-light-blue');
  useEffect(() => {
    const update = () => setTheme(localStorage.getItem('selected-theme') || 'lara-light-blue');
    window.addEventListener(browserPreferencesResetEvent, update);
    return () => window.removeEventListener(browserPreferencesResetEvent, update);
  }, []);

  return (
    <div className="flex align-items-center gap-2">
      <ThemeAppearance />
      <Dropdown
        value={theme}
        options={Themes}
        onChange={(e) => { localStorage.setItem('selected-theme', e.value); setTheme(e.value); window.dispatchEvent(new Event(themeChangedEvent)); }}
        placeholder="Select Theme"
        className="w-15rem"
        scrollHeight={'500px'}
      />
   </div>
  );
}
